import React from "react";
import { Gift, ExternalLink } from "lucide-react";
import { SOCIALS } from "../mock";

const Giveaways = () => {
  return (
    <section id="giveaways" className="relative py-24 px-5 bg-[#2a2249]">
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          {/* text */}
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-[#edbb23]/15 border border-[#edbb23]/40 px-4 py-1.5 mb-5">
              <Gift size={15} className="text-[#edbb23]" />
              <span className="text-xs font-extrabold tracking-widest text-[#edbb23]">GIVEAWAYS</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-white tracking-tight">SOL Giveaways on X</h2>
            <p className="mt-5 text-[#b7b0d6] leading-relaxed">
              I regularly send out <span className="text-white font-semibold">SOL</span> to the community through giveaways
              on X. Follow me, turn on notifications and never miss a drop — winners get paid out straight to their wallet.
            </p>
            <a
              href={SOCIALS.x}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-7 inline-flex items-center gap-2 bg-[#1d1d1f] hover:bg-[#2c2c2f] border border-[#3a3a40] text-white font-extrabold rounded-xl px-7 h-12 transition-colors"
            >
              <img src="/assets/x-white.png" alt="" className="w-4 h-4 object-contain" />
              FOLLOW ON X <ExternalLink size={16} />
            </a>
          </div>

          {/* proof image */}
          <div className="rounded-2xl border border-[#473c7d] bg-[#161620] p-3 shadow-xl">
            <img src="/assets/sol-giveaway.png" alt="Recent SOL giveaways" className="w-full rounded-xl" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Giveaways;
